import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';

interface ElementPropertyByElementState {
  ElementPropertyByElement: {
    load: boolean;
    data: [];
  };
}

export const ElementPropertyByElementSlice = createSlice({
  name: "ElementPropertyByElement",
  initialState: {
    ElementPropertyByElement: {
      load: false,
      data: [],
    },
  } as ElementPropertyByElementState,
  reducers: {
    resetElementPropertyByElementState: (state: any) => {
      state.ElementPropertyByElement.data = [];
    },
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(
        fetchElementPropertyByElement.pending,
        (state: ElementPropertyByElementState) => {
          state.ElementPropertyByElement.load = true;
        }
      )
      .addCase(
        fetchElementPropertyByElement.fulfilled,
        (state: ElementPropertyByElementState, action: any) => {
          state.ElementPropertyByElement.data = action.payload;
          state.ElementPropertyByElement.load = false;
        }
      )
      .addCase(
        fetchElementPropertyByElement.rejected,
        (state: ElementPropertyByElementState) => {
          state.ElementPropertyByElement.load = false;
        }
      );
  },
});

export const { resetElementPropertyByElementState } =
  ElementPropertyByElementSlice.actions;
export default ElementPropertyByElementSlice.reducer;

export const fetchElementPropertyByElement = createAsyncThunk(
  "ElementPropertyByElement/fetchElementPropertyByElement",
  async (
    param: {
      apiParam: { warehouse_id: any; tpi_firm_id: any; summary_element_pin: any, project_pin: any, route_identify: any };
    },
    thunkAPI
  ) => {
    try {
      const { data } = await DataServer.post(
        "api/getElementPropertyByElementType",
        {
          warehouse_id: param.apiParam.warehouse_id,
          tpi_firm_id: param.apiParam.tpi_firm_id,
          summary_element_pin: param.apiParam.summary_element_pin,
          project_pin: param.apiParam.project_pin,
          route_identify: param.apiParam.route_identify
        }
      );

      return data.data;
    } catch (error) {
      return error;
    }
  }
);

export const updateBoqReport = createAsyncThunk(
  "ElementPropertyByElement/updateBoqReport",
  async (param: { apiParam: { inspection_boq: any, warehouse_id: any; tpi_firm_id: any; summary_element_pin: any, login_user_id: any, project_pin: any, route_identify: any } }, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/updateBoqReport", {
        inspection_boq: JSON.stringify(param.apiParam.inspection_boq),
        login_user_id: param.apiParam.login_user_id
      });

      toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

      const handleonConfirm = () => {
        thunkAPI.dispatch(fetchElementPropertyByElement({apiParam: {
            warehouse_id: param.apiParam.warehouse_id,
            tpi_firm_id: param.apiParam.tpi_firm_id,
            summary_element_pin: param.apiParam.summary_element_pin,
            project_pin: param.apiParam.project_pin,
            route_identify: param.apiParam.route_identify
        }}))
      };

      return data.data;
    } catch (error) {
      toast.error("Something went wrong!",{theme: "colored"});
      return error;
    }
  }
);


export const DeleteElementProperty = createAsyncThunk(
  "ElementPropertyByElement/updateBoqReport",
  async (param: { apiParam: { element_property_pin: any; tpi_firm_id: any; element_pin: any, warehouse_id: any, summary_element_pin: any, project_pin: any, route_identify: any } }, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/deleteElementProperty", {
        element_property_pin: param.apiParam.element_property_pin,
        tpi_firm_id: param.apiParam.tpi_firm_id,
        element_pin: param.apiParam.element_pin
      });

      if(data.message === "Element property already assigned and used"){
        toast.warning(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});
      } else {
        toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});
      }

      const handleonConfirm = () => {
        thunkAPI.dispatch(fetchElementPropertyByElement({apiParam: {
            warehouse_id: param.apiParam.warehouse_id,
            tpi_firm_id: param.apiParam.tpi_firm_id,
            summary_element_pin: param.apiParam.summary_element_pin,
            project_pin: param.apiParam.project_pin,
            route_identify: param.apiParam.route_identify
        }}))
      };

      return data.data;
    } catch (error) {
      return error;
    }
  }
);